.ugc-review-progress-wrap {
  .item {
    .star-number-text {
      min-width: 46px;
      text-align: right;
    }
    .each-count {
      width: 56px;
      text-align: center;
    }
  }
  .percent-wrap {
    overflow: hidden;
    &:hover {
      span {
        background: var(--green-dark);
      }
    }
    span {
      border-radius: inherit;
      transition: width 0.6s ease 0s;
    }
  }
}
